import React from 'react';
import Spin from 'antd/lib/spin';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SearchPriceOffersInfo from '../../blocks/PageInfo/SearchPriceOffersInfo';
import style from './SearchPriceOffers.module.scss';
import api from '../../../helpers/api';
import getReferrerFrom from '../../../helpers/lib/getReferrerFrom';

const SearchPriceOffersContent = () => {
  const [loading, setLoading] = React.useState<boolean>(true);
  const history = useHistory();
  const [iframe, setIframe] = React.useState<any>();

  const onReport = async () => {
    await api.sendReport(api.API_OFFERS_REQUEST_REPORT_TYPE, {
      ...getReferrerFrom(),
    });
  };

  const [isError, setIsError] = React.useState<boolean>(false);
  // @ts-ignore
  const user = useSelector((state) => state.user.userData?.additionalData);

  React.useEffect(() => {
    (async () => {
      if (!user) return;

      const isValid = !!user?.kupec;

      if (!isValid) {
        history.push('/');
        return;
      }

      const userData = JSON.stringify({
        userId: user?.userId,
        organisationRegistrationCode: user?.organisationRegistrationCode,
        userPersonalName: decodeURIComponent(user?.userPersonalName),
        bankAccount: {
          bik: user?.['bankAccount[bik]'],
          accountNumber: user?.['bankAccount[accountNumber]'],
        },
      });

      try {
        const result = await api.getKupecFrame(userData);
        if (!result) {
          setLoading(false);
          return;
        }

        setIframe(result);
      } catch (e) {
        setIsError(true);
        console.log(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [user, history]);

  return (
    <>
      <div className={style.container}>
        <SearchPriceOffersInfo />
      </div>
      <div className={style.frame}>
        {!loading && !isError && (
          <iframe onLoad={onReport} width="100%" height="100%" src={iframe?.url} title="Kupec iframe" />
        )}
        {isError && (
          <div className={style.spin}>
            <div>
              <div>
                Сервис недоступен, обратитесь пожалуйста в техническую поддержку{' '}
                <a href="mailto:help@tektorg.ru">help@tektorg.ru</a>
              </div>
              <div>{iframe?.message}</div>
            </div>
          </div>
        )}
        {loading && (
          <div className={style.spin}>
            <Spin />
          </div>
        )}
      </div>
    </>
  );
};

export default SearchPriceOffersContent;
